import { render, staticRenderFns } from "./AllLoanTransactions.vue?vue&type=template&id=79d8337c"
import script from "./AllLoanTransactions.vue?vue&type=script&lang=js"
export * from "./AllLoanTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports